import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Phoenix-Portal-App root. Now just the top-level router-outlet so individual routes
 * can pick their own frame:
 *  - `/` renders the public landing page FULL-BLEED (no shell chrome — PBI 1467).
 *  - `/board`, `/runs`, `/backup-environments`, `/no-access` render inside
 *    {@link ShellLayoutComponent}, which wraps the shared `cs-shell` (sidebar + header
 *    + auth-ready gating).
 *
 * The shell composition (auth probe, config, interceptor, language switch) that used to
 * live here moved into {@link ShellLayoutComponent}; the shared SERVICES still come from
 * `provideShell(...)` in app.config (root-level APP_INITIALIZER), so auth/B2C bootstrap
 * is unaffected by which route is active.
 */
@Component({
  selector: 'phoenix-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {}
